export default {
	game: {
		maintenance: 'Đang Bảo trì',
		maintenance_tip: 'Tạm thời không thể vào',
		no_more_data: 'Không còn dữ liệu',
		search_game_name: 'Tìm tên game...',
		selected: 'Đã chọn',
		type: 'Loại',
		all_types: 'Tất cả loại',
		secondary: 'Phụ',
		secondary_category: 'Danh mục phụ',
		no_related_games: 'Không tìm thấy game liên quan',
		reset_all: 'Đặt lại tất cả',
		end_of_list: 'Hết danh sách',
		game_details: 'Chi tiết Game',
		play: 'Chơi',
		bonus_cannot_wagered: 'Bonus không thể đặt cược',
		entering_game: 'Đang vào game, vui lòng chờ...',
		entering_game_short: 'Đang vào Game...',
		game_types: 'Loại Game',
		game_providers: 'Nhà cung cấp Game',
		sign_up: 'Đăng ký',
		search: 'Tìm kiếm',
		all_providers: 'Tất cả Nhà cung cấp',
		loading: 'Đang tải...',
		my_bet: 'Cược của tôi'
	}
};